module.exports = new __parcel__URL__("shop_stake_button_inactive.e41f723b.png").toString();